import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import noop from 'lodash/noop';
import map from 'lodash/map';
import includes from 'lodash/includes';

import FilterButton from './FilterButton';

const FilterButtonGroup = ({
  styles,
  data = {},
  terms = [],
  colorMap = {},
  filters = [],
  onClick = noop,
  selectedSource = 'allSources',
  onShowTrendingModal,
  onToggleAnalysisModal
}) => {

  const onClickAnalysis = (index, count) => {
    if (count > 1000000) {
      onToggleAnalysisModal();
    } else {
      onShowTrendingModal(index);
    }
  };

  return (
    <div
      className={styles.FilterButtonGroup}
    >
      {map(data, (term, index) => {
        let count = term.total;
        if (selectedSource !== 'allSources') {
          // Specific source
          count = term.sources[selectedSource] || 0;
        }
        return (
          <div className={styles.filterButtonContainer} key={`container-${term}-${index}`}>
            <FilterButton
              key={`filter-button-${term}-${index}`}
              onClick={() => onClick(term, index)}
              color={colorMap[index]}
              term={terms[index]}
              count={count}
              filtered={includes(filters, index)}
            />
            <div
              key={`analysis-${term}-${index}`}
              className={styles.analysisButton}
              onClick={() => onClickAnalysis(index, count)}
              id="analysisButton"
            >
              Analysis
            </div>
          </div>
        );
      })}
    </div>
  );
};

FilterButtonGroup.propTypes = {
  styles: PropTypes.object.isRequired,
  terms: PropTypes.array,
  data: PropTypes.array,
  colorMap: PropTypes.array,
  filters: PropTypes.array,
  onClick: PropTypes.func,
  selectedSource: PropTypes.string,
  onShowTrendingModal: PropTypes.func.isRequired,
  onToggleAnalysisModal: PropTypes.func.isRequired,
};

export default themeable(FilterButtonGroup);
